module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.notifications) ? _c('notification-list-table') : _vm._e(), _vm._v(" "), _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notificationsPageCount > 1),
      expression: "notificationsPageCount > 1"
    }]
  }, [_c('paginate', {
    ref: "notificationsPaginate",
    attrs: {
      "pageCount": _vm.notificationsPageCount,
      "initial-page": 0,
      "clickHandler": _vm.notificationsPaginate,
      "container-class": 'pagination justify-content-center',
      "page-class": 'page-item',
      "page-link-class": 'page-link',
      "prev-class": 'page-item',
      "prev-link-class": 'page-link',
      "next-class": 'page-item',
      "next-link-class": 'page-link'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('notification.list.filter'),
      "label-for": "notificationListFilter"
    }
  }, [_c('div', {
    attrs: {
      "role": "group",
      "id": "notificationListFilter"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "seen",
      "value": "seen"
    },
    model: {
      value: (_vm.notificationListFilter),
      callback: function($$v) {
        _vm.notificationListFilter = $$v
      },
      expression: "notificationListFilter"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('notification.list.filter.seen')) + "\n        ")])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "disabled": _vm.refreshingNotifications
    },
    on: {
      "click": _vm.refreshNotifications
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    class: {
      'fa-spin': _vm.refreshingNotifications
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29738ccf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/NotificationList.vue
// module id = 490
// module chunks = 0